import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import view from "../../images/view.png";
import {
    FAMILY_USERS,
    MLT_USERS,
    TOUCHES_CHART_FAMILY_URL,
    TOUCHES_CHART_SITES_URL,
    TOUCHES_CHART_YEAR_URL,
    TOUCHES_DETAILS_FILTER_URL, 
    TOUCHES_SEGMENT_DONUT_URL
} from "../ApiDetails.js";
import Header from "../HeaderAdmin.js";
import Navbar from "../Navbar.js";
import Submenu from "../Submenu.js";
import BarChartEvent from "./BarChartEvent.js";
import DonutChartAssociates from "./DonutChartAssociate.js";
import DonutChartFormat from "./DonutChartFormat.js";
import "./touchesReport.css";

const TouchesReport = () => {
    const [sortBy, setSortBy] = useState("Newest");
    const [reportsData, setReportsData] = useState([]);
    const [barGraphData, setBarGraphData] = useState([]);
    const [barGraphValue, setBarGraphValue] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [DonutChartFormatData, setDonutChartFormatData] = useState([]);
    const [DonutChartAssociateData, setDonutChartAssociateData] = useState([]);
    const navigate = useNavigate();
    const [yearlyEventCounts, setYearlyEventCounts] = useState({
        2022: 0,
        2023: 0,
        2024: 0,
        2025: 0,
        2026: 0,
        2027: 0,
    });

    const pagesToShow = 4;

    // Filters Values
    const [famMem, setFamMem] = useState([]);
    const [mltUserMembers, setMltUserMembers] = useState([]);
  
    const gMarsCache = JSON.parse(localStorage.getItem('MarsCache'));

    const [navBarMltValue, setNavBarMltValue] = useState(false);


    const [reportsFilter, setReportsFilter] = useState({
        selectedSegment: "All",
        selectedCountry: "All",
        selectedSite: "All",
        selectedSiteType: "All",
        selectedFamGen: "All",
        selectedfamMem: "All",
        selectedmltMem: "All",
        selectedStatus: "All",
        selectedEventType: "All",
        selectedEventFormat: "All",
        startDate: "",
        endDate: "",
        graphDropdownValue: "family",
        reRender: "no",
    });

    const element = document.getElementById("navBarMltValue");
    if (element) {
        element.addEventListener("change", () => {
            setNavBarMltValue(element.checked);
        });
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [
                    mltUserResponse,
                ] = await Promise.all([
                    axios.get(MLT_USERS),
                ]);
                setMltUserMembers(mltUserResponse.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const fetchFamilyMembers = async () => {
            try {
                const response = await axios.get(FAMILY_USERS);
                setFamMem(response.data);
            } catch (error) {
                console.error("Error fetching family members:", error);
            }
        };
        fetchFamilyMembers();
    }, []);


    // method to fetch the data for bar chart
    useEffect(() => {

        const directBargraphFilter = async () => {
            try {
                const {
                    selectedSegment,
                    selectedCountry,
                    selectedSite,
                    selectedSiteType,
                    selectedFamGen,
                    selectedfamMem,
                    selectedmltMem,
                    selectedStatus,
                    selectedEventType,
                    selectedEventFormat,
                    startDate,
                    endDate,
                    graphDropdownValue,
                } = reportsFilter;

                const filterParams = new URLSearchParams();

                if (selectedSegment && selectedSegment !== "All") {
                    filterParams.append("Segment", selectedSegment);
                }
                if (selectedCountry && selectedCountry !== "All") {
                    filterParams.append("Country", selectedCountry);
                }
                if (selectedSite && selectedSite !== "All") {
                    filterParams.append("Site", selectedSite.split(" ")[0]);
                }
                if (selectedSiteType && selectedSiteType !== "All") {
                    filterParams.append("SiteType", selectedSiteType);
                }
                if (navBarMltValue) {
                    if (selectedmltMem && selectedmltMem !== "All") {
                        filterParams.append("Member", selectedmltMem);
                    }
                } else {
                    if (selectedfamMem && selectedfamMem !== "All") {
                        filterParams.append("Member", selectedfamMem);
                    }
                }
                if (selectedFamGen && selectedFamGen !== "All") {
                  filterParams.append("FamilyGeneration", selectedFamGen);
                }
                if (selectedStatus && selectedStatus !== "All") {
                    filterParams.append("Status", selectedStatus);
                }
                if (selectedEventType && selectedEventType !== "All") {
                    filterParams.append("Type", selectedEventType);
                }
                if (selectedEventFormat && selectedEventFormat !== "All") {
                    filterParams.append("Format", selectedEventFormat);
                }
                if (startDate) {
                    filterParams.append("StartDate", startDate);
                } if (endDate) {
                    filterParams.append("EndDate", endDate);
                }
                filterParams.append("MLTSwitch", navBarMltValue);


                if (graphDropdownValue && graphDropdownValue === "family") {
                    const apiUrl = `${TOUCHES_CHART_FAMILY_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
                    const result = await axios.get(apiUrl);
                    setBarGraphData(result.data)
                }
                if (graphDropdownValue && graphDropdownValue === "most") {
                    const apiUrl = `${TOUCHES_CHART_SITES_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
                    const result = await axios.get(apiUrl);
                    setBarGraphData(result.data)
                }
                if (graphDropdownValue && graphDropdownValue === "least") {
                    const apiUrl = `${TOUCHES_CHART_SITES_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
                    const result = await axios.get(apiUrl);
                    setBarGraphData(result.data)
                }
                if (graphDropdownValue && graphDropdownValue === "year") {
                    const apiUrl = `${TOUCHES_CHART_YEAR_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
                    const result = await axios.get(apiUrl);
                    setBarGraphData(result.data)
                }
            } catch (error) {
                console.error("Error while fetching Graph data:", error);
            }
        };

        directBargraphFilter();

    }, [reportsFilter.graphDropdownValue, reportsFilter.reRender, navBarMltValue]);

    // Fetch intial details
    useEffect(() => {
        const initialFetch = async () => {
            try {

                const filterParams = new URLSearchParams();
                filterParams.append("MLTSwitch", navBarMltValue);

                const apiUrl = `${TOUCHES_DETAILS_FILTER_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
                const response = await axios.get(apiUrl);
                setReportsData(response.data);


                const AssociateDonutURL = `${TOUCHES_SEGMENT_DONUT_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
                const response2 = await axios.get(AssociateDonutURL);
                setDonutChartAssociateData(response2.data);
            } catch (error) {
                console.error("Error fetching initial data:", error);
            }
        };
        initialFetch();
    }, [reportsFilter.reRender, navBarMltValue]);

    // Function to fetch event details based on filters
    const handleApplyFilterClick = async () => {
        setIsLoading(true);
        try {
            const {
                selectedSegment,
                selectedCountry,
                selectedSite,
                selectedSiteType,
                selectedFamGen,
                selectedfamMem,
                selectedmltMem,
                selectedStatus,
                selectedEventType,
                selectedEventFormat,
                startDate,
                endDate,
                graphDropdownValue,
            } = reportsFilter;


            const filterParams = new URLSearchParams();

            if (selectedSegment && selectedSegment !== "All") {
                filterParams.append("Segment", selectedSegment);
            }
            if (selectedCountry && selectedCountry !== "All") {
                filterParams.append("Country", selectedCountry);
            }
            if (selectedSite && selectedSite !== "All") {
                filterParams.append("Site", selectedSite.split(" ")[0]);
            }
            if (selectedSiteType && selectedSiteType !== "All") {
                filterParams.append("SiteType", selectedSiteType);
            }
            if (navBarMltValue) {
                if (selectedmltMem && selectedmltMem !== "All") {
                    filterParams.append("Member", selectedmltMem);
                }
            } else {
                if (selectedfamMem && selectedfamMem !== "All") {
                    filterParams.append("Member", selectedfamMem);
                }
            }
            if (selectedFamGen && selectedFamGen !== "All") {
                filterParams.append("FamilyGeneration", selectedFamGen);
            }
            if (selectedStatus && selectedStatus !== "All") {
                filterParams.append("Status", selectedStatus);
            }
            if (selectedEventType && selectedEventType !== "All") {
                filterParams.append("Type", selectedEventType);
            }
            if (selectedEventFormat && selectedEventFormat !== "All") {
                filterParams.append("Format", selectedEventFormat);
            }
            if (startDate) {
                filterParams.append("StartDate", startDate);
            }
            if (endDate) {
                filterParams.append("EndDate", endDate);
            }

            filterParams.append("MLTSwitch", navBarMltValue);


            const apiUrl = `${TOUCHES_DETAILS_FILTER_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
            const response = await axios.get(apiUrl);
            setReportsData(response.data);

            const AssociateDonutURL = `${TOUCHES_SEGMENT_DONUT_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;

            const response2 = await axios.get(AssociateDonutURL);
            setDonutChartAssociateData(response2.data);

            if (graphDropdownValue && graphDropdownValue === "family") {
                const apiUrl = `${TOUCHES_CHART_FAMILY_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
                const result = await axios.get(apiUrl);
                setBarGraphData(result.data)
            }
            if (graphDropdownValue && graphDropdownValue === "most") {
                const apiUrl = `${TOUCHES_CHART_SITES_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
                const result = await axios.get(apiUrl);
                setBarGraphData(result.data)
            }
            if (graphDropdownValue && graphDropdownValue === "least") {
                const apiUrl = `${TOUCHES_CHART_SITES_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
                const result = await axios.get(apiUrl);
                setBarGraphData(result.data)
            }
            if (graphDropdownValue && graphDropdownValue === "year") {
                const apiUrl = `${TOUCHES_CHART_YEAR_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
                const result = await axios.get(apiUrl);
                setBarGraphData(result.data)
            }
            paginate(1);
        } catch (error) {
            console.error("Error fetching filtered event details:", error);
        } finally {
            setIsLoading(false);
        }
    };

    // Function to clear all filters
    const handleClearAllFilters = () => {
        setReportsFilter((prevState) => ({
            ...prevState,
            selectedSegment: "All",
            selectedCountry: "All",
            selectedSite: "All",
            selectedSiteType: "All",
            selectedFamGen: "All",
            selectedfamMem: "All",
            selectedmltMem: "All",
            selectedStatus: "All",
            selectedEventType: "All",
            selectedEventFormat: "All",
            startDate: "",
            endDate: "",
            graphDropdownValue: "family",
            reRender: prevState.reRender === "yes" ? "no" : "yes", // Toggle reRender value
        }));
        setReportsData([]);
        paginate(1);
    };

    // Pagination logic
    const totalPages = Math.ceil(reportsData.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = reportsData.sort(function(a, b) {
        if (sortBy==="Newest") return new Date(b.eventDate) - new Date(a.eventDate);
                          else return new Date(a.eventDate)- new Date(b.eventDate);
      }).slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => {
        if (pageNumber < 1) {
            pageNumber = 1;
        } else if (pageNumber > totalPages) {
            pageNumber = totalPages;
        }
        setCurrentPage(pageNumber);
    };

    const pageNumbers = [];
    for (
        let i = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
        i <= Math.min(totalPages, currentPage + Math.floor(pagesToShow / 2));
        i++
    ) {
        pageNumbers.push(i);
    }

    // method to set data for touches by format donut

    useEffect(() => {
        const filteredEventFormats = reportsData.reduce((acc, event) => {
            const eventFormat = event.eventFormat;
            const touches = event.touches || 0;
            acc[eventFormat] = (acc[eventFormat] || 0) + touches;
            return acc;
        }, {});

        setDonutChartFormatData(filteredEventFormats);
    }, [reportsData]);


    // method to set barChart data.

    useEffect(() => {

        var processedData = null;

        if (reportsFilter.graphDropdownValue === "year") {

            processedData = barGraphData
                .sort((a, b) => {
                    // If sorting by year, arrange in ascending order
                    if (/^\d{4}$/.test(a.associatesCategory)) {
                        return parseInt(a.associatesCategory) - parseInt(b.associatesCategory);
                    }
                    // Otherwise, arrange by associateCount in descending order
                    return b.associateCount - a.associateCount;
                })
                .map((item) => ({
                    x: item.associatesCategory,
                    y: item.associateCount,
                }));
        } else {

            if (reportsFilter.graphDropdownValue === "most") {
                processedData = barGraphData
                    .sort((a, b) => b.associateCount - a.associateCount)
                    .slice(0, 10)
                    .map((item) => ({
                        x: item.associatesCategory,
                        y: item.associateCount
                    }));
            } else {

                if (reportsFilter.graphDropdownValue === "least") {
                    processedData = barGraphData
                        .sort((a, b) => a.associateCount - b.associateCount)
                        .slice(0, 10)
                        .map((item) => ({
                            x: item.associatesCategory,
                            y: item.associateCount
                        }));
                } else {

                    processedData = barGraphData
                        .sort((a, b) => b.associateCount - a.associateCount) // Sort by eventcount in descending order
                        .map((item) => ({
                            x: item.associatesCategory,
                            y: item.associateCount
                        }));
                }
            }
        }
        setBarGraphValue(processedData);
    }, [barGraphData]);

    // method to set data for touches according to years.

    useEffect(() => {

        const fetchYearData = async () => {
            try {
                const eventData = reportsData;
                if (!eventData || eventData.length === 0) {
                    return;
                }

                // Accumulate touches count by year
                // Dynamically track years within a range instead of hardcoding
                const minYear = 2022;
                const maxYear = new Date().getFullYear() + 5; // Future-proofing

                const yearTouches = eventData.reduce((counts, event) => {
                    if (!event.eventDate) return counts; // Skip invalid entries

                    const eventYear = new Date(event.eventDate).getFullYear();

                    if (eventYear >= minYear && eventYear <= maxYear) {
                        counts[eventYear] = (counts[eventYear] || 0) + (event.touches || 0);
                    }
                    return counts;
                }, {});

                setYearlyEventCounts(yearTouches);

            } catch (error) {
                console.error("Error fetching data for years:", error);
            }
        };
        fetchYearData();

    }, [reportsData]);

    const handleEventview = (event) => {
        if (event.eventID) {
            const url = `/GetDetailAdmin/${event.eventID}`;
            navigate(url);
        }
    };

    return (
        <div>
            <Header />
            <div className="reportsContainerPadding">
                <Navbar />
                <div className="single-card-container">
                    <div className="cards submenuContainer">
                        < Submenu reportsData={reportsData} />
                    </div>
                </div>

                <div
                    style={{
                        filter: isLoading ? "blur(2px)" : "none",
                        transition: "filter 0.3s ease",
                    }}
                >
                    <div className="single-card-container filter">
                        <div className="cards">
                            <div className="row">
                                <div className="d-flex bd-highlight eventReportFiltersContainer align-items-center">
                                    <div className="p-2 flex-fill bd-highlight text-center">
                                        <h4 className="reportTitle mt-4">FILTERS</h4>
                                    </div>
                                    <div className="p-2 col-10 d-flex align-content-start flex-wrap">
                                        <div className="col-12">
                                            <div className="row eventReportFiltersSpacing">
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="segment"
                                                        >
                                                            SEGMENT
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label="Segment"
                                                            id="segment"
                                                            value={reportsFilter.selectedSegment}
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    selectedSegment: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {gMarsCache.EventAssociates.length > 0 &&
                                                                gMarsCache.EventAssociates.map((segmentName, index) => (
                                                                    <option key={index} value={segmentName}>
                                                                        {segmentName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="country"
                                                        >
                                                            COUNTRY
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label="Country"
                                                            id="country"
                                                            value={reportsFilter.selectedCountry} // Bind value to state
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    selectedCountry: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {gMarsCache.Countries.length > 0 &&
                                                                gMarsCache.Countries.map((countryName, index) => (
                                                                    <option key={index} value={countryName}>
                                                                        {countryName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="site"
                                                        >
                                                            SITE CODE
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label="Site"
                                                            id="site"
                                                            value={reportsFilter.selectedSite} // Bind value to state
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    selectedSite: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {gMarsCache.SiteDetails.length > 0 &&
                                                                gMarsCache.SiteDetails.map((site, index) => (
                                                                    <option key={index} value={site.name}>
                                                                        {site.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                  <div className="input-group mb-0">
                                                    <label className="input-group-text input-group-text-custom" htmlFor="site">SITE TYPE</label>
                                                    <select
                                                      className="form-control-custom rounded form-select"
                                                      aria-label="Site"
                                                      id="siteType"
                                                      value={reportsFilter.selectedSiteType} // Bind value to state
                                                      onChange={(e) => {
                                                        setReportsFilter({
                                                          ...reportsFilter,
                                                          selectedSiteType: e.target.value,
                                                        });
                                                      }}
                                                    >
                                                      <option value="All">All</option>
                                                      {gMarsCache.SiteTypes.length > 0 &&
                                                         gMarsCache.SiteTypes.map((siteType, index) => (
                                                              <option key={index} value={siteType.code}>
                                                                  {siteType.name}
                                                              </option>
                                                          ))}
                                                    </select>
                                                  </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor={navBarMltValue ? "mltMem" : "famMem"}
                                                        >
                                                            {navBarMltValue ? "MLT MEMBERS" : "FAMILY MEMBERS"}
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label={navBarMltValue ? "mltMem" : "famMem"}
                                                            id={navBarMltValue ? "mltMem" : "famMem"}
                                                            value={
                                                                navBarMltValue
                                                                    ? reportsFilter.selectedmltMem
                                                                    : reportsFilter.selectedfamMem
                                                            } // Corrected value binding
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    [navBarMltValue ? "selectedmltMem" : "selectedfamMem"]: e.target.value, // Corrected state update
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {(navBarMltValue ? mltUserMembers : famMem).map((memName, index) => (
                                                                // TODO: Switch to user.ID if possible.
                                                                <option key={index} value={memName.fullname}>
                                                                    {memName.fullname}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                  <div className="input-group mb-0">
                                                    <label
                                                      className="input-group-text input-group-text-custom"
                                                      htmlFor="famGen"
                                                    >FAMILY GENERATION</label>
                                                    <select
                                                      className="form-control-custom rounded form-select"
                                                      aria-label="Family generation"
                                                      id="famGen"
                                                      value={reportsFilter.selectedFamGen}
                                                      onChange={(e) => {
                                                        setReportsFilter({
                                                          ...reportsFilter,
                                                          selectedFamGen: e.target.value,
                                                        });
                                                      }}
                                                    >
                                                      <option value="All">All</option>
                                                      <option value="1">G1</option>
                                                      <option value="2">G2</option>
                                                      <option value="3">G3</option>
                                                      <option value="4">G4</option>
                                                      <option value="5">G5</option>
                                                      <option value="6">G6</option>
                                                      <option value="7">G7</option>
                                                      <option value="8">G8</option>
                                                    </select>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="row mt-4 eventReportFiltersSpacing">
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="status"
                                                        >
                                                            STATUS
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label="Status"
                                                            id="status"
                                                            value={reportsFilter.selectedStatus} // Bind value to state
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    selectedStatus: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {gMarsCache.EventStatus.length > 0 &&
                                                                gMarsCache.EventStatus.map((statusName, index) => (
                                                                    <option key={index} value={statusName}>
                                                                        {statusName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="eventType"
                                                        >
                                                            EVENT TYPE
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label="Event Type"
                                                            id="eventType"
                                                            value={reportsFilter.selectedEventType} // Bind value to state
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    selectedEventType: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {gMarsCache.EventTypes.length > 0 &&
                                                                gMarsCache.EventTypes.map((eventName, index) => (
                                                                    <option key={index} value={eventName}>
                                                                        {eventName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="eventFormat"
                                                        >
                                                            EVENT FORMAT
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label="Event Format"
                                                            id="eventFormat"
                                                            value={reportsFilter.selectedEventFormat} // Bind value to state
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    selectedEventFormat: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {gMarsCache.EventFormats.length > 0 &&
                                                                gMarsCache.EventFormats.map((formatName, index) => (
                                                                    <option key={index} value={formatName}>
                                                                        {formatName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="startDate"
                                                        >
                                                            START DATE
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control-custom rounded form-control text-cursor"
                                                            id="startDate"
                                                            value={reportsFilter.startDate} // Bind value to state
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    startDate: e.target.value,
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="endDate"
                                                        >
                                                            END DATE
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control-custom rounded form-control text-cursor"
                                                            id="endDate"
                                                            value={reportsFilter.endDate} // Bind value to state
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    endDate: e.target.value,
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="mb-3">
                                                        <div className="input-group mb-0">
                                                            <label
                                                                className="input-group-text input-group-text-custom"
                                                                htmlFor="sortBy"
                                                            >
                                                                Sort By
                                                            </label>
                                                            <select
                                                                className="form-control-custom rounded form-select"
                                                                aria-label="Sort By"
                                                                id="sortBy"
                                                                value={sortBy}
                                                                onChange={(e) => setSortBy(e.target.value)}
                                                            >
                                                                <option value="Newest">Newest</option>
                                                                <option value="Oldest">Oldest</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-1 text-end d-flex flex-column align-items-end justify-content-center eventReportsFiltersButtons">
                                        <button
                                            className="btn-primary-custom p-1 mt-4"
                                            onClick={handleApplyFilterClick}
                                        >
                                            Apply Filters
                                        </button>
                                        <button
                                            className="btn-secondary-custom"
                                            onClick={handleClearAllFilters}
                                        >
                                            Clear All
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* New container for the charts */}
                    <div className="card-container">
                        {/* Donut Chart */}
                        <div className="cards">
                            <div className="card-header">SEGMENT</div>
                              <div className="donut-container">
                                <DonutChartAssociates associateData={DonutChartAssociateData} />
                              </div>
                        </div>

                        {/* Bar Chart */}
                        <div className="cards">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="card-header">TOUCHES REPARTITION</div>
                            <div className="form-group mb-3">
                                <select 
                                    className="form-control form-select custom-select chart-dropdown"
                                    aria-label="MARS Family"
                                    value={reportsFilter.graphDropdownValue}
                                    onChange={(e) => {
                                        setReportsFilter({
                                            ...reportsFilter,
                                            graphDropdownValue: e.target.value,
                                        });
                                    }}
                                >
                                    <option value="family">Touches by member</option>
                                    {/* <option value="touch">Most Touches</option> */}
                                    <option value="most">Sites with most touches</option>
                                    <option value="least">Sites with least touches</option>
                                    <option value="year">Event evolution per year</option>
                                </select>
                            </div>
                          </div>
                          <BarChartEvent filteredData={barGraphValue} name="Total Touches"/>
                        </div>
                    </div>

                    {/* completed touches and future touches */}
                    <div className="report-container">
                        <div className="touches-segment">
                            <div className="segment completed-touches">
                                <h3 className="segment-title">COMPLETED TOUCHES</h3>
                                <div className="touches-container">
                                    <div className="touch-item year">2022</div>
                                    <div className="touch-item year">2023</div>
                                    <div className="touch-item high">2024</div>
                                </div>
                                <div className="touches-container">
                                    <div className="touch-item">{yearlyEventCounts[2022]}</div>
                                    <div className="touch-item">{yearlyEventCounts[2023]}</div>
                                    <div className="touch-item">{yearlyEventCounts[2024]}</div>
                                </div>
                            </div>

                            <div className="segment future-touches">
                                <h3 className="segment-title">FUTURE TOUCHES</h3>
                                <div className="touches-container">
                                    <div className="touch-item year">2025</div>
                                    <div className="touch-item year">2026</div>
                                    <div className="touch-item year">2027</div>
                                </div>
                                <div className="touches-container">
                                    <div className="touch-item">{yearlyEventCounts[2025]}</div>
                                    <div className="touch-item">{yearlyEventCounts[2026]}</div>
                                    <div className="touch-item">{yearlyEventCounts[2027]}</div>
                                </div>
                            </div>
                        </div>
                        <div className="chart-container">
                            {/* Placeholder for your Donut Chart Component */}
                            <div className="donut-chart">
                                <h3 className="segment-title">TOUCHES BY FORMAT</h3>
                                {/* Insert your chart component here */}
                                <DonutChartFormat eventData={DonutChartFormatData} />
                            </div>
                        </div>
                    </div>

                    {/* Table for displaying report data */}
                    <div className="single-card-container">
                        <div className="cards-table">
                            <div className="grid-container-events">
                                <div className="grid-header-first">SITE</div>
                                <div className="grid-header">LOCATION</div>
                                <div className="grid-header">DATE</div>
                                <div className="grid-header">VISITOR</div>
                                <div className="grid-header">EVENT TYPE</div>
                                <div className="grid-header">SEGMENT</div>
                                <div className="grid-header">FORMAT</div>
                                <div className="grid-header">TOUCHES</div>
                                <div className="grid-header">OFF SITE</div>
                                <div className="grid-header">STATUS</div>
                                <div className="grid-header-last">SEE EVENTS</div>
                                {currentItems.length > 0 ? (
                                    currentItems.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <div className="grid-item-first">{item.siteCode}</div>
                                            <div className="grid-item">{item.eventVenueName!=="" ? item.eventVenueName : item.eventAddress}</div>
                                            <div className="grid-item">{new Date(item.eventDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}</div>
                                            <div className="grid-item">{item.nameOfMem}</div>
                                            <div className="grid-item">{item.eventType}</div>
                                            <div className="grid-item">{item.associates}</div>
                                            <div className="grid-item">{item.eventFormat}</div>
                                            <div className="grid-item">{item.touches}</div>
                                            <div className="grid-item">{item.siteCode === "OFF" ? "YES" : "NO"}</div>
                                            <div className="grid-item">{item.eventStatus}</div>
                                            <div className="grid-item-last">
                                                <button
                                                    className="btn btn-icon"
                                                    onClick={() => handleEventview(item)}
                                                >
                                                    <img
                                                        src={view}
                                                        alt="Edit"
                                                        width={24}
                                                        height={24}
                                                    />
                                                </button>
                                            </div>
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <div
                                        className="grid-item"
                                        style={{ gridColumn: "1 / -1", textAlign: "center" }}
                                    >
                                        No events found
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Pagination */}
                    <nav aria-label="Page navigation">
                        <ul className="pagination-report justify-content-center">
                            <li className={`page-item-report ${currentPage === 1 ? "disabled-report" : ""}`}>
                                <button
                                    className="page-link-report"
                                    onClick={() => paginate(currentPage - 1)}
                                >
                                    Previous
                                </button>
                            </li>
                            {pageNumbers.map((number) => (
                                <li
                                    key={number}
                                    className={`page-item-report ${number === currentPage ? "active-report" : ""}`}
                                >
                                    <button onClick={() => paginate(number)} className="page-link-report">
                                        {number}
                                    </button>
                                </li>
                            ))}
                            <li
                                className={`page-item-report ${currentPage === totalPages ? "disabled-report" : ""}`}
                            >
                                <button
                                    className="page-link-report"
                                    onClick={() => paginate(currentPage + 1)}
                                >
                                    Next
                                </button>
                            </li>
                        </ul>
                    </nav>
                    {isLoading && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100vw",
                                height: "100vh",
                                backgroundColor: "rgba(255, 255, 255, 0.1)", // Semi-transparent background
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 9999, // Ensure the loader is on top of everything
                            }}
                        >
                            <CircularProgress />
                        </div>
                    )}
                </div>

            </div>

        </div>
    );
};

export default TouchesReport;
